/* ==========================================================
   Bundle Offer (Buy X Get Y)
   - "Add this" card on qualifying product pages (.js-bundle-add-pair)
   - Build Your Bundle popup ([data-open-bundle-modal])
   - Cart drawer nudge (.js-bundle-add-reward)
   The discount itself is an automatic Shopify discount; this file only
   adds the right items to the bag. Config: window.bundleOffer
   (snippets/bundle-modal.liquid, Theme settings > Bundle Offer).
   ========================================================== */
$(document).ready(function () {
  /* ---------- Volume / Multi-Buy Deal Handlers ---------- */
  $(document).on("click", ".js-volume-deal-add", async function (e) {
    e.preventDefault();
    const $btn = $(this);
    const variantId = $btn.attr("data-variant-id") || $("#productForm input[name='id']").val();
    const qty = parseInt($btn.attr("data-min-qty"), 10) || 3;
    if (!variantId) return;

    // Also sync product page quantity field if present
    const $qtyInput = $("#productForm input[name='quantity']");
    if ($qtyInput.length) {
      $qtyInput.val(qty);
    }

    if (window.ThemeCart && typeof window.ThemeCart.addItem === "function") {
      const origText = $btn.text();
      $btn.text("ADDING...").addClass("is-loading").prop("disabled", true);
      try {
        await window.ThemeCart.addItem({ id: Number(variantId), quantity: qty });
      } finally {
        $btn.text(origText).removeClass("is-loading").prop("disabled", false);
      }
    } else {
      $("#productForm").submit();
    }
  });

  $(document).on("click", ".js-volume-deal-add-one", async function (e) {
    e.preventDefault();
    const $btn = $(this);
    const variantId = $btn.attr("data-variant-id");
    if (!variantId || !window.ThemeCart) return;

    const origText = $btn.text();
    $btn.text("ADDING...").prop("disabled", true);
    try {
      await window.ThemeCart.addItem({ id: Number(variantId), quantity: 1 });
    } finally {
      $btn.text(origText).prop("disabled", false);
    }
  });

  const config = window.bundleOffer;
  if (!config) return;

  const $modal = $("#bundleModal");
  let lastTrigger = null;

  /* ---------- Helpers ---------- */
  function formatMoney(cents) {
    const format = (window.themeSettings && window.themeSettings.moneyFormat) || "£{{amount}}";
    const value = (parseInt(cents, 10) || 0) / 100;
    const withDelimiters = function (num, decimals, thousands, decimal) {
      const parts = num.toFixed(decimals).split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case "amount_no_decimals": return withDelimiters(value, 0, ",", ".");
        case "amount_with_comma_separator": return withDelimiters(value, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return withDelimiters(value, 0, ".", ",");
        default: return withDelimiters(value, 2, ",", ".");
      }
    });
  }

  // True when the bag already holds a reward item that is not yet paired
  // with a qualifying product — adding a qualifier alone will unlock it.
  async function hasUnpairedReward() {
    try {
      const cart = await window.ThemeCart.getCart();
      let rewardQty = 0;
      let qualifierQty = 0;
      cart.items.forEach(function (item) {
        if (item.product_id === config.rewardProductId) rewardQty += item.quantity;
        if (config.qualifierProductIds.indexOf(item.product_id) !== -1) qualifierQty += item.quantity;
      });
      return rewardQty > qualifierQty;
    } catch (e) {
      return false;
    }
  }

  async function addBundle(plannerVariantId, plannerQty, $btn) {
    if (!plannerVariantId || !window.ThemeCart) return;

    const origText = $btn.text();
    $btn.text("ADDING...").addClass("is-loading").prop("disabled", true);

    const items = [{ id: Number(plannerVariantId), quantity: plannerQty || 1 }];
    if (!(await hasUnpairedReward())) {
      items.push({ id: Number(config.rewardVariantId), quantity: 1 });
    }

    try {
      await window.ThemeCart.addItem({ items: items });
    } finally {
      $btn.text(origText).removeClass("is-loading").prop("disabled", false);
    }
  }

  /* ---------- Product page: add current product + reward ---------- */
  $(document).on("click", ".js-bundle-add-pair", function (e) {
    e.preventDefault();
    const $form = $("#productForm");
    const variantId = $form.find("input[name='id']").val();
    const qty = parseInt($form.find("input[name='quantity']").val(), 10) || 1;
    addBundle(variantId, qty, $(this));
  });

  /* ---------- Cart drawer nudge: add reward only ---------- */
  $(document).on("click", ".js-bundle-add-reward", async function (e) {
    e.preventDefault();
    const $btn = $(this);
    const origText = $btn.text();
    $btn.text("ADDING...").prop("disabled", true);
    try {
      await window.ThemeCart.addItem({ id: Number(config.rewardVariantId), quantity: 1 });
    } finally {
      // Drawer re-renders on success; this only matters if the add failed
      $btn.text(origText).prop("disabled", false);
    }
  });

  if (!$modal.length) return;

  /* ---------- Modal: pricing ---------- */
  const $addBtn = $("#bundleModalAdd");
  const rewardPrice = parseInt($addBtn.attr("data-reward-price"), 10) || 0;
  const rewardDiscounted = parseInt($addBtn.attr("data-reward-discounted"), 10) || 0;

  function selectedPlanner() {
    const $radio = $modal.find(".bundle-planner-input:checked");
    if (!$radio.length) return null;
    const $select = $radio.closest(".bundle-planner-option").find(".bundle-planner-variant");
    if ($select.length) {
      const $opt = $select.find("option:selected");
      return { id: $opt.val(), price: parseInt($opt.attr("data-price"), 10) || 0 };
    }
    return { id: $radio.val(), price: parseInt($radio.attr("data-price"), 10) || 0 };
  }

  function updateTotals() {
    const planner = selectedPlanner();
    $modal.find(".bundle-planner-option").removeClass("is-selected");
    $modal.find(".bundle-planner-input:checked").closest(".bundle-planner-option").addClass("is-selected");

    if (!planner) {
      $("#bundleTotal").text("");
      $("#bundleTotalCompare").text("");
      $addBtn.prop("disabled", true);
      return;
    }
    $addBtn.prop("disabled", false);
    $("#bundleTotal").text(formatMoney(planner.price + rewardDiscounted));
    $("#bundleTotalCompare").text(formatMoney(planner.price + rewardPrice));
  }

  $modal.on("change", ".bundle-planner-input", updateTotals);
  $modal.on("change", ".bundle-planner-variant", function () {
    const $option = $(this).closest(".bundle-planner-option");
    const $selected = $(this).find("option:selected");
    $option.find(".bundle-planner-price").text(formatMoney($selected.attr("data-price")));
    $option.find(".bundle-planner-input").prop("checked", true);
    updateTotals();
  });

  /* ---------- Modal: open / close ---------- */
  function openModal() {
    lastTrigger = document.activeElement;
    if (window.ThemeCart && typeof window.ThemeCart.closeDrawer === "function") {
      window.ThemeCart.closeDrawer();
    }
    if (window.lenis) window.lenis.stop();
    updateTotals();
    $modal.addClass("open").attr("aria-hidden", "false");
    $("body").addClass("bundle-modal-open");
    setTimeout(function () {
      const $focus = $modal.find(".bundle-planner-input:checked");
      ($focus.length ? $focus : $modal.find(".bundle-modal-close")).trigger("focus");
    }, 100);
  }

  function closeModal() {
    if (!$modal.hasClass("open")) return;
    $modal.removeClass("open").attr("aria-hidden", "true");
    $("body").removeClass("bundle-modal-open");
    if (window.lenis && !$("body").is(".nav-open, .cart-open, .search-open")) {
      window.lenis.start();
    }
    if (lastTrigger && typeof lastTrigger.focus === "function") {
      lastTrigger.focus();
      lastTrigger = null;
    }
  }

  $(document).on("click", "[data-open-bundle-modal]", function (e) {
    e.preventDefault();
    openModal();
  });

  $modal.on("click", "[data-bundle-close]", closeModal);

  $(document).on("keydown", function (e) {
    if (!$modal.hasClass("open")) return;
    if (e.key === "Escape") {
      closeModal();
      return;
    }
    if (e.key === "Tab") {
      const $focusable = $modal.find("button:not([disabled]), input:not([disabled]), select:not([disabled]), a[href]").filter(":visible");
      if (!$focusable.length) return;
      const first = $focusable.get(0);
      const last = $focusable.get($focusable.length - 1);
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  /* ---------- Modal: add bundle ---------- */
  $addBtn.on("click", async function (e) {
    e.preventDefault();
    const planner = selectedPlanner();
    if (!planner) return;
    await addBundle(planner.id, 1, $addBtn);
    lastTrigger = null;
    closeModal();
  });
});
